import Breadcrumbs from "../../../components/breadcrumbs";
import ShoppingCategoryCreateForm from "./ui/shopping-category-create-form";

export default function ShoppingCategoryCreatePage() {
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Shopping Categories", href: "/admin/shopping-category" },
          {
            label: "create",
            href: "/admin/shopping-category/create",
            active: true,
          },
        ]}
      />
      <ShoppingCategoryCreateForm />
    </main>
  );
}
